import styled from 'styled-components';

export const AlertContainer = styled.div`
  margin-bottom: 24px;
`;
